module.exports = __webpack_public_path__ + "img/logo-on-white.79687855.png";